import { render, staticRenderFns } from "./DepartmentButtonSelectorDialog.vue?vue&type=template&id=59d182da&scoped=true&"
import script from "./DepartmentButtonSelectorDialog.vue?vue&type=script&lang=ts&"
export * from "./DepartmentButtonSelectorDialog.vue?vue&type=script&lang=ts&"
import style0 from "./DepartmentButtonSelectorDialog.vue?vue&type=style&index=0&id=59d182da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59d182da",
  null
  
)

export default component.exports